module.exports = __webpack_public_path__ + "img/icon-eye.1ac4e1f2.svg";